import axios, { AxiosStatic } from 'axios'

const BASE_URL = process.env.REACT_APP_ENV === 'prod'
    ? 'https://api.loomis.be/Loomis/'
    : 'https://laboapi.loomis.be/Loomis/'


export default axios.create({
    baseURL: BASE_URL,
    headers: { 'Content-Type': 'application/json' },
})



export const axiosPrivate = axios.create({
    baseURL: BASE_URL,
    headers: { 'Content-Type': 'application/json' }
})

